

import InternationalPhoneInputSelect from "../../../components/InternationalPhoneInputSelect";
import Consents from "../../../components/Consents";
import {mapGetters} from "vuex";

export default {
  name: "index",
  components: {InternationalPhoneInputSelect, Consents},
  data: function () {
    return {
      sentReminder: false,
      hasApiErrors: false,
      first_name: '',
      last_name: '',
      email: '',
      mobile: {},
      consents_touched: false,
      agree_to_terms: false,
      loading: false,
      journey_step: 'CREATE_CLAIMER',
      two_factor_code: null,
      claimer_attributes: null,
      api_errors_to_component_errors: {
        account_id: false,
        email: 'email',
        mobile_number: 'mobile_number',
        two_factor_code: 'two_factor_code',
        first_name: 'first_name',
        last_name: 'last_name'
      },


    }
  },

  computed: {
    ...mapGetters({
      styles: "getCustomStyles",
      groupedFulfilmentConfig: 'basket/getGroupedFulfilmentConfig',
      account: 'getAccount',
      consents: 'getAccountConsents'
    }),

  swiper() {
      return this.$refs.imageSwiper.$swiper
    },

    swiperOptions() {
      return {
        notNextTick: false,
        loop: !!this.referralScheme.claim_images_slideshow,
        initialSlide: 0,
        autoplay: this.referralScheme.claim_images_slideshow ? {
          delay: this.referralScheme.claim_images_slide_interval * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        } : false,
        speed: 1000,
        direction: 'horizontal',
        grabCursor: true,
        on: {
          slideChangeTransitionStart: function() {
          },
        },
      };
    },

    referralScheme(){
      const scheme = this.$store.getters.getReferralSchemeBySlug(this.$route.params.slug);

      return scheme;
    },

    referrer() {
      return this.$store.getters.getReferralSchemeByReferrerSlug(this.$route.params.slug);
    },

    schemeClosed() {
      if (!!this.referralScheme && !!this.referrer) {
        const inactive = !this.referralScheme.active
        const limitReached = this.referralScheme.claimers_per_referrer_limit !== null && (this.referrer.claimers_total >= this.referralScheme.claimers_per_referrer_limit);
        return inactive || limitReached
      }
      return false
    },

    /**
     * Return the referrers mobile with the
     * First part redacted
     *
     * @returns {string}
     */
    redactedMobile() {

      const mobile = this.mobile.lineNumber;

      const last4Digits = mobile.substr(mobile.length - 4);

      return `*******${last4Digits}`;

    },

    redactedEmail() {
      const email = this.email;

      const emailArr = email.split('@');

      const str = emailArr[0];

      return str[0] + new Array(str.length - 2).join('*') + str[str.length - 1] + '@' + emailArr[1];

    },

    /**
     * Get a formatted referral gift value
     * i.e. £5
     *
     * @returns {string}
     */
    formattedReferralGiftValue() {
      return `${this.account.Currency.symbol}${this.referral_scheme.referrer_gift_value / this.account.Currency.denomination} `
    },

    /**
     * Get the referral link made up of the account domain
     * And the auto generated server slug
     *
     * @returns {string}
     */
    referralLink() {
      let link = '';

      if (this.claimer_attributes.slug) {
        link = `https://${this.account.domain}/${this.claimer_attributes.slug}`
      }

      return link;
    }

  },

  methods: {

    copyReferralLink() {
      navigator.clipboard.writeText(this.referralLink);
    },

    /**
     * Form submission for signup
     */
    claim() {
      this.$validator.validateAll().then(success => {

        if (success) {

          this.errors.clear();
          this.loading = true;

          let variables = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            country_code: `+${this.mobile.areaCode}`,
            mobile_number: this.mobile.lineNumber,
            agree_to_terms: this.agree_to_terms,
            journey_step: this.journey_step,
            referral_scheme_id: this.referralScheme.id,
            referrer_slug: this.$route.params.slug,
            consents: this.consents
          }

          if (this.consents.length) {
            variables.marketing_consent_accepted = this.consents[0].optin === 1;
          }

          this.$axios({
            url: process.env.VUE_APP_API_GRAPH_URL,
            method: "post",
            data: {
              query: `
                      mutation (
                            $first_name:String,
                            $last_name:String,
                            $email:String,
                            $country_code:String,
                            $mobile_number:String,
                            $agree_to_terms:Boolean,
                            $marketing_consent_accepted:Boolean,
                            $referrer_slug:String!,
                            $consents:[ConsentInput]
                          ){
                            createClaimer(
                                first_name: $first_name,
                                last_name: $last_name,
                                email: $email,
                                country_code: $country_code,
                                mobile_number: $mobile_number,
                                agree_to_terms: $agree_to_terms,
                                marketing_consent_accepted: $marketing_consent_accepted,
                                referrer_slug: $referrer_slug,
                                consents: $consents
                            ){
                              client_attributes
                            }
                      }
                    `,
              variables: variables,
            },
          })
            .then((result) => {

              if (this.validateGraphResponse(result.data, this.api_errors_to_component_errors)) {
                this.journey_step = 'TWO_FACTOR_CONFIRM';
              } else if (result.data.errors && result.data.errors[0].validation.ReferralScheme) {
                this.errors.add({ field: "referral_scheme", msg: result.data.errors[0].validation.ReferralScheme[0] });
              } else {

                this.hasApiErrors = true;
              }

            })
            .catch((err) => {
              this.customerError = "An error has occurred, please try again.";
            })
            .finally(() => {
              this.loading = false;
            });
        }

      })
    },

    /**
     *
     */
    twoFactorConfirm() {

      this.hasApiErrors = false;

      this.$validator.validate('two_factor_code', this.two_factor_code).then(success => {

        if (success) {

          this.errors.clear();
          this.loading = true;

          const variables = {
            mobile_number: this.mobile.lineNumber,
            referrer_slug : this.$route.params.slug,
            two_factor_code: this.two_factor_code
          }

          this.$axios({
            url: process.env.VUE_APP_API_GRAPH_URL,
            method: "post",
            data: {
              query: `
                      mutation (
                            $mobile_number:String!,
                            $referrer_slug:String!
                            $two_factor_code:String!
                          ){
                            claimerConfirmTwoFactor(
                                mobile_number: $mobile_number,
                                referrer_slug: $referrer_slug
                                two_factor_code: $two_factor_code
                            ){
                              client_attributes
                            }
                      }
                    `,
              variables: variables,
            },
          })
            .then((result) => {
              if (this.validateGraphResponse(result.data, this.api_errors_to_component_errors)) {

                this.journey_step = 'CONFIRMATION_PAGE';
                this.claimer_attributes = JSON.parse(result.data.data.claimerConfirmTwoFactor.client_attributes);

              } else {
                this.hasApiErrors = true;
              }
            })
            .catch((err) => {
              this.customerError = "An error has occurred, please try again.";
            })
            .finally(() => {
              this.loading = false
            });

        }
      })
    },

    /**
     * Send reminder if referrer already signed up
     */
    sendReminder() {
      this.errors.clear();
      this.loading = true;

      let variables = {
        mobile_number: this.mobile.lineNumber,
        referrer_slug : this.$route.params.slug
      }

      this.$axios({
        url: process.env.VUE_APP_API_GRAPH_URL,
        method: "post",
        data: {
          query: `
                      mutation (
                        $mobile_number:String!,
                        $referrer_slug:String!

                          ){
                            claimerSendReminder(
                              mobile_number: $mobile_number,
                              referrer_slug: $referrer_slug
                            ){
                              client_attributes
                            }
                      }
                    `,
          variables: variables,
        },
      })
        .then((result) => {
          if (this.validateGraphResponse(result.data, this.api_errors_to_component_errors)) {

          }
        })
        .catch((err) => {
          this.customerError = "An error has occurred, please try again.";
        })
        .finally(() => {
          this.loading = false;
          this.sentReminder = true;
        });
    },

    /**
     * Resend the two factor code to the user
     */
    resendTwoFactorCode() {

      this.errors.clear();
      this.loading = true;

      let variables = {
        mobile_number: this.mobile.lineNumber,
        referrer_slug: this.$route.params.slug
      }

      this.$axios({
        url: process.env.VUE_APP_API_GRAPH_URL,
        method: "post",
        data: {
          query: `
                      mutation (
                            $mobile_number:String!,
                            $referrer_slug:String!
                          ){
                            claimerSendTwoFactor(
                              mobile_number: $mobile_number,
                              referrer_slug: $referrer_slug
                            ){
                              client_attributes
                            }
                      }
                    `,
          variables: variables,
        },
      })
        .then((result) => {
          if (this.validateGraphResponse(result.data, this.api_errors_to_component_errors)) {

          }
        })
        .catch((err) => {
          this.customerError = "An error has occurred, please try again.";
        })
        .finally(() => {
          this.two_factor_code = null;
          this.loading = false
        });
    },

  },

  created(){
    this.loading = true;
  },

  mounted() {

    this.getReferrerFile(this.$route.params.slug).finally(() => {
      this.loading = false;
    });

    //set all consent optins to 0
    for (let i = this.consents.length - 1; i >= 0; i--) {
      this.consents[i].optin = null;
    }

  },

  head() {
      if(this.referralScheme)
        return {
            title: this.referralScheme.claim_page_title + ' - ' + this.account.name
        }
  }
}
